import { apiGateway } from '../api';

async function getMotivosValoresSegundaVia(numContrato = '') {
    try {
        const response = await apiGateway.get(`/carteiras/segunda-via/motivos-valores?numContrato=${numContrato}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function solicitaSegundaVia(body) {
    try {
        const response = await apiGateway.post('/carteiras/segunda-via', body);
        return response.data;
    } catch (error) {
        return error;
    }
}

async function imagemCarteirinha(body) {
    try {
        const response = await apiGateway.post(`/beneficiario/carteirinha/imagem`, body, { responseType: 'blob' });
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function carteirinhaDigitalSaude(body) {
    try {
        const response = await apiGateway.post(`carteirinha-digital/carteirinha/Saude`, body);
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

export { getMotivosValoresSegundaVia, solicitaSegundaVia, imagemCarteirinha, carteirinhaDigitalSaude };
